import React from 'react'
import CreateVirtualCardForm from 'src/app/CreateVirtualCardForm/CreateVirtualCardForm'
import RightFlyout, {
  RightFlyoutBodyWidths,
} from 'src/components/RightFlyout/RightFlyout'

const CreateVirtualCard: React.FC = () => {
  return (
    <RightFlyout width={RightFlyoutBodyWidths.Action}>
      <CreateVirtualCardForm />
    </RightFlyout>
  )
}

export default CreateVirtualCard
